import { render } from "./TipFeesInfoTipper.vue?vue&type=template&id=8eed7294&scoped=true"
import script from "./TipFeesInfoTipper.vue?vue&type=script&lang=js"
export * from "./TipFeesInfoTipper.vue?vue&type=script&lang=js"

import "./TipFeesInfoTipper.vue?vue&type=style&index=0&id=8eed7294&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eed7294"]])

export default __exports__